export default __webpack_public_path__ + "static/PernodRicard-30af6188392a631eaca82bb5bef24e2e.png";